import { type UseTranslation, useUntypedTranslation } from "@fideus/i18n";

export const useTranslation: UseTranslation<"de"> = useUntypedTranslation;
